import { render, staticRenderFns } from "./ContractTpl.vue?vue&type=template&id=5fc1461c&scoped=true"
import script from "./ContractTpl.vue?vue&type=script&lang=js"
export * from "./ContractTpl.vue?vue&type=script&lang=js"
import style0 from "./ContractTpl.vue?vue&type=style&index=0&id=5fc1461c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1461c",
  null
  
)

export default component.exports